import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";

export function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) { navigate("/portal/login"); return; }
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        localStorage.setItem("bzl_token", data.session_token);
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.role === "admin" ? "/admin" : "/portal", { state: { user: data.user } });
      })
      .catch(() => navigate("/portal/login"));
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-[#191713] flex items-center justify-center text-[#9A9184] text-sm" data-testid="auth-callback">
      Signing you in…
    </div>
  );
}

export default function MagicVerify() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const { t } = useLang();
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const token = new URLSearchParams((location.hash || "").replace(/^#/, "")).get("token");
    if (!token) { setError(t.login2.magicInvalid); return; }
    api.post("/auth/magic/verify", { token })
      .then(({ data }) => {
        localStorage.setItem("bzl_token", data.access_token);
        setUser(data.user);
        navigate(data.user.role === "admin" ? "/admin" : "/portal", { state: { user: data.user } });
      })
      .catch(() => setError(t.login2.magicInvalid));
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-[#191713] flex flex-col items-center justify-center gap-5 px-6" data-testid="magic-verify-page">
      {error ? (
        <>
          <p className="text-sm text-red-400" data-testid="magic-error">{error}</p>
          <Link to="/portal/login" className="btn-gold">{t.login.back}</Link>
        </>
      ) : (
        <p className="text-sm text-[#9A9184]">Signing you in…</p>
      )}
    </div>
  );
}
